import {useFetch} from "../useFetch";
import {GetContainerPlatformsByIdDto} from "../../types/api/guide/containerPlatform.types";
import {containerPlatformService} from "../../services/guide/containerPlatform-service";


export const useFetchContainerPlatformsById = (id: string) => {
    const { isLoading, error, data } =
        useFetch<GetContainerPlatformsByIdDto>(containerPlatformService.getById, [id]);

    return { data: data as GetContainerPlatformsByIdDto, isLoading, error };
}